import styled, { css } from 'styled-components'
import { InView } from 'react-intersection-observer'
import { C009StyledProposition, StyledInViewProps } from './types'
import { colorToLunaToken } from '../../../helpers/theming/utilities'
import { RichText } from '../../../helpers/StyledWrappers.styles'

const textColor = (props) => {
  return css`
    ${props.textTheme === 'dark' ? props.theme.color.monochrome.darker : props.theme.color.monochrome.white};
  `
}

const wrapperCss = css<C009StyledProposition>`
  ${(props) => css`
    color: ${textColor(props)};
    border-radius: ${props.theme.size.border.radius.base};
    background-color: ${props.backgroundColor
      ? colorToLunaToken(props.backgroundColor, props.theme)
      : props.theme.color.monochrome.lighter};
    font-size: ${props.theme.font.size.caption};
    @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
      font-size: ${props.theme.font.size.base};
    }
  `}
`
export const StyledSmallProposition = styled.button<C009StyledProposition>`
  ${wrapperCss}

  display: flex;
  justify-content: center;
  min-height: 58px;
  border: none;
  width: 100%;
  padding: ${(props) => props.theme.size.spacing.md};

  > div:first-of-type {
    max-width: 800px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;

    @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
      align-items: center;
    }
  }

  picture {
    height: 50px;

    @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
      height: 40px;
    }

    img {
      height: 100%;
      max-width: unset;
    }
  }
`

export const StyledCopy = styled.div<C009StyledProposition>`
  ${(props) =>
    props.isSmall &&
    css`
      padding-left: ${props.theme.size.spacing.lg};

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        padding: 0 ${props.theme.size.spacing.lg};
      }
    `};
`

export const StyledContentWrapper = styled.div`
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    display: flex;
    align-items: center;
  }
`

export const StyledLink = styled.span<C009StyledProposition>`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  text-decoration: underline;
  height: 25px;

  ${(props) => css`
    font-weight: ${props.theme.font.weight.bold};
    padding-left: ${props.theme.size.spacing.lg};
    padding-top: ${props.theme.size.spacing.md};
  `}

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    height: 32px;

    ${(props) => css`
      border-left: ${props.theme.size.border.width.sm} solid ${textColor(props)};
      padding-left: ${props.theme.size.spacing.md};
      padding-top: 0;
    `}
  }
`

export const StyledProposition = styled.div<C009StyledProposition>`
  ${wrapperCss}

  display: grid;
  padding: ${(props) => props.theme.size.spacing.lg};
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    grid-auto-flow: column;
    align-items: center;
    grid-auto-columns: 1fr;
  }

  > div:first-of-type {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: ${(props) => props.theme.size.spacing.lg};

    @media screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].xs}) {
      order: 1;
      margin: ${(props) => props.theme.size.spacing.lg} 0 0;
    }
  }

  button,
  a {
    width: fit-content;
    border-color: currentColor;
    background-color: transparent;
    color: currentColor;
    margin-top: ${(props) => props.theme.size.spacing.lg};

    &:hover {
      border-color: currentColor;
      background-color: transparent;
      color: currentColor;
    }
  }

  img {
    width: 100%;
  }
`

export const StyledRichTextWrapper = styled.div`
  ${RichText}
  p {
    margin: 0;
  }
`

export const StyledInView = styled(InView)<StyledInViewProps>`
  ${(props) =>
    props.showMargin &&
    css`
      margin-bottom: ${props.theme.size.spacing.lg};
    `};
`
